module.exports = __webpack_public_path__ + "static/media/envelope-open.04418633.svg";